export default __webpack_public_path__ + "media/XSOLIS_logo.2c3fb3c3.png";